
<script context="module">

import { 
  VmDefaultUi,
  VmCaptionControl,
  VmControl,
  VmIcon,
  VmTooltip,
  VmCaptions,
  VmClickToPlay,
  VmControlGroup,
  VmControlSpacer,
  VmControls,
  VmCurrentTime,
  VmTime,
  VmDblClickFullscreen,
  VmDefaultControls,
  VmEndTime,
  VmFullscreenControl,
  VmLiveIndicator,
  VmMuteControl,
  VmPipControl,
  VmPlaybackControl,
  VmScrim,
  VmScrubberControl,
  VmSlider,
  VmSettingsControl,
  VmTimeProgress,
  VmVolumeControl,
  VmDefaultSettings,
  VmMenu,
  VmMenuItem,
  VmMenuRadio,
  VmMenuRadioGroup,
  VmSettings,
  VmSubmenu,
  VmLoadingScreen,
  VmPoster,
  VmSpinner,
  VmUi 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-default-ui', VmDefaultUi);
define('vm-caption-control', VmCaptionControl);
define('vm-control', VmControl);
define('vm-icon', VmIcon);
define('vm-tooltip', VmTooltip);
define('vm-captions', VmCaptions);
define('vm-click-to-play', VmClickToPlay);
define('vm-control-group', VmControlGroup);
define('vm-control-spacer', VmControlSpacer);
define('vm-controls', VmControls);
define('vm-current-time', VmCurrentTime);
define('vm-time', VmTime);
define('vm-dbl-click-fullscreen', VmDblClickFullscreen);
define('vm-default-controls', VmDefaultControls);
define('vm-end-time', VmEndTime);
define('vm-fullscreen-control', VmFullscreenControl);
define('vm-live-indicator', VmLiveIndicator);
define('vm-mute-control', VmMuteControl);
define('vm-pip-control', VmPipControl);
define('vm-playback-control', VmPlaybackControl);
define('vm-scrim', VmScrim);
define('vm-scrubber-control', VmScrubberControl);
define('vm-slider', VmSlider);
define('vm-settings-control', VmSettingsControl);
define('vm-time-progress', VmTimeProgress);
define('vm-volume-control', VmVolumeControl);
define('vm-default-settings', VmDefaultSettings);
define('vm-menu', VmMenu);
define('vm-menu-item', VmMenuItem);
define('vm-menu-radio', VmMenuRadio);
define('vm-menu-radio-group', VmMenuRadioGroup);
define('vm-settings', VmSettings);
define('vm-submenu', VmSubmenu);
define('vm-loading-screen', VmLoadingScreen);
define('vm-poster', VmPoster);
define('vm-spinner', VmSpinner);
define('vm-ui', VmUi);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className = '';

export let style = '';
export { className as class };

export let noClickToPlay = false;
export let noDblClickFullscreen = false;
export let noCaptions = false;
export let noPoster = false;
export let noSpinner = false;
export let noControls = false;
export let noSettings = false;
export let noLoadingScreen = false;

export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => {
  

  __mounted = true;
});



const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-default-ui
  class={className}
  style={style}
  no-click-to-play={noClickToPlay}
  no-dbl-click-fullscreen={noDblClickFullscreen}
  no-captions={noCaptions}
  no-poster={noPoster}
  no-spinner={noSpinner}
  no-controls={noControls}
  no-settings={noSettings}
  no-loading-screen={noLoadingScreen}
  
  bind:this={__ref}
>
  <slot></slot>
</vm-default-ui>
  